<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทสินค้าถือครอง:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'houProductTypeId'"
                  :name="'houProductTypeId'"
                  :select2-options="houProductTypeIdOptions"
                  v-model="houProductTypeId"
                  ref="houProductTypeIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ระยะเวลาการถือครอง (วัน):</label>
                <input
                  id="houHolderTime"
                  name="houHolderTime"
                  v-model="houHolderTime"
                  type="number"
                  min="1"
                  maxlength="450"
                  class="form-control"
                  placeholder="ระยะเวลาการถือครอง"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label>ตัวแทนจำหน่าย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'houAgentCode'"
                  :name="'houAgentCode'"
                  :select2-options="houAgentCodeOptions"
                  @selectChange="onHouAgentCodeChange"
                  v-model="houAgentCode"
                  ref="houAgentCodeSelect2"
                ></select2>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label>ประเภทร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'houShopTypeCode'"
                  :name="'houShopTypeCode'"
                  :select2-options="houShopTypeCodeOptions"
                  v-model="houShopTypeCode"
                  ref="houShopTypeCodeSelect2"
                ></select2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label>แบรนด์สินค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'houProductBrandId'"
                  :name="'houProductBrandId'"
                  :select2-options="houProductBrandIdOptions"
                  v-model="houProductBrandId"
                  ref="houProductBrandIdSelect2"
                ></select2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="houInActiveStatus"
                      id="houInActiveStatus"
                      v-model="houInActiveStatus"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      isChange: false,
      houProductTypeId: null,
      houHolderTime: null,
      houAgentCode: null,
      houShopTypeCode: null,
      houProductBrandId: null,
      houInActiveStatus: true,
      // Configurations
      houProductTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductType/Select2ProductType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      houAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      houShopTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      houProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      axios
        .put("/Api/ProductHolder", {
          ProductTypeId: this.houProductTypeId,
          HolderTime: this.houHolderTime,
          AgentCode: this.houAgentCode,
          ShopTypeId: this.houShopTypeCode,
          ProductBrandId: this.houProductBrandId,
          InActiveStatus: !this.houInActiveStatus,
          ProductHolderId: this.$route.params.id,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onHouAgentCodeChange: function(ref) {
      // this.$refs.houShopTypeCodeSelect2.setSelectedData({
      //   id: "",
      //   text: ""
      // });
      if (this.isChange) {
        $("#houShopTypeCode")
          .val("")
          .trigger("change");
      }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        houProductTypeId: "required",
        houHolderTime: "required",
        // houAgentCode: "required",
        // houShopTypeCode: "required",
        // houProductBrandId: "required"
      },
      messages: {
        houProductTypeId: "กรุณาเลือกประเภทสินค้าถือครอง",
        houHolderTime: "กรุณากรอกระยะเวลาการถือครอง",
        // houAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        // houShopTypeCode: "กรุณาเลือกประเภทร้านค้า",
        // houProductBrandId: "กรุณาเลือกแบรนด์สินค้า"
      },
    });

    axios
      .get("/Api/ProductHolder/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.houHolderTime = response.data.holderTime;
          self.houInActiveStatus = !response.data.inActiveStatus;

          if (response.data.productTypeID) {
            self.$refs.houProductTypeIdSelect2.setSelectedData({
              id: response.data.productTypeID,
              text: response.data.productTypeName,
            });
          }

          if (response.data.agentCode) {
            self.$refs.houAgentCodeSelect2.setSelectedData({
              id: response.data.agentCode,
              text: response.data.agentCodeName,
            });
          }

          if (response.data.shopTypeId) {
            self.$refs.houShopTypeCodeSelect2.setSelectedData({
              id: response.data.shopTypeId,
              text: response.data.shopTypeName,
            });
          }

          if (response.data.productBrandID) {
            self.$refs.houProductBrandIdSelect2.setSelectedData({
              id: response.data.productBrandID,
              text: response.data.productBrandName,
            });
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการถือครองที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการถือครองได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        self.isChange = true;
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Holding/HoldingUpdate.vue